var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunFog29(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 9.33333H11.9999C12.0053 9.33333 12.0099 9.334 12.0133 9.33333C12.3819 9.33333 12.6799 9.03467 12.6799 8.66667C12.6799 8.61733 12.6746 8.56933 12.6653 8.52333C12.5886 6.016 10.5253 4 7.99992 4C5.42725 4 3.33325 6.09333 3.33325 8.66667C3.33325 9.03467 3.63125 9.33333 3.99992 9.33333Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 10.6667H0.666667C0.298 10.6667 0 10.9654 0 11.3334C0 11.7014 0.298 12 0.666667 12H15.3333C15.702 12 16 11.7014 16 11.3334C16 10.9654 15.702 10.6667 15.3333 10.6667Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3334H2.66667C2.298 13.3334 2 13.632 2 14C2 14.368 2.298 14.6667 2.66667 14.6667H13.3333C13.702 14.6667 14 14.368 14 14C14 13.632 13.702 13.3334 13.3333 13.3334Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66659 0.666687H7.33325V2.66669H8.66659V0.666687Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1286 3.48107L13.1858 2.53827L11.7716 3.95247L12.7144 4.89527L14.1286 3.48107Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33333L16 8L14 8L14 9.33333L16 9.33333Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2862 4.89556L4.229 3.95276L2.8148 2.53856L1.872 3.48136L3.2862 4.89556Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.33333L2 8H0L0 9.33333H2Z",
    fill: "#FF4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunFog29);
export default __webpack_public_path__ + "static/media/sun-fog-29.74b7df53a7c3c0a4d2dcdca47ef0b9e3.svg";
export { ForwardRef as ReactComponent };